module.exports = __webpack_public_path__ + "static/media/Loading.52c2e68c.svg";